module.exports = __webpack_public_path__ + "static/media/GrinningFace.012d284c.png";